import { ListDealsRequestContent, ListDealsResponseContent } from "@equaliq/api-model-v2";
import { createApiRequest } from "../common";

/**
 * API function to list deals
 * @param request Optional filters for listing deals
 * @returns Promise with list of deals
 */
export const listDealsApi = async (request?: ListDealsRequestContent): Promise<ListDealsResponseContent> => {
  const apiRequest = createApiRequest<ListDealsResponseContent>('post', '/deals/list');
  return apiRequest(request || {});
};
